<form [formGroup]="partnerForm" novalidate>
  <div class="mock-form-grid partner-inscription-grid">
    <div class="partner-inscription-field partner-inscription-field--search-end">
      <umkt-custom-input
        formControlName="cnpj"
        [placeholder]="'pages.partnerRegistration.inscription.step1.fields.cnpj.placeholder' | i18n"
        [floatingLabel]="true"
        mask="AA.AAA.AAA/AAAA-00"
        [showSearchIcon]="true"
        [showClearButton]="false"
        (searchSubmit)="onCnpjSearchClick()"
      ></umkt-custom-input>
    </div>
    <div class="partner-inscription-field">
      <umkt-custom-input
        formControlName="telefone"
        [placeholder]="'pages.partnerRegistration.inscription.step1.fields.telefone.placeholder' | i18n"
        [floatingLabel]="true"
        mask="(00) 0000-0000 ||(00) 00000-0000"
        [showClearButton]="false"
      ></umkt-custom-input>
    </div>
    <div class="partner-inscription-field">
      <umkt-custom-input
        formControlName="razaoSocial"
        [placeholder]="'pages.partnerRegistration.inscription.step1.fields.razaoSocial.placeholder' | i18n"
        [floatingLabel]="true"
        [maxlength]="255"
        [showClearButton]="false"
      ></umkt-custom-input>
    </div>
    <div class="partner-inscription-field">
      <umkt-custom-input
        formControlName="setorAtuacao"
        [placeholder]="'pages.partnerRegistration.inscription.step1.fields.setorAtuacao.placeholder' | i18n"
        [floatingLabel]="true"
        [maxlength]="255"
        [showClearButton]="false"
      ></umkt-custom-input>
    </div>
    <div class="partner-inscription-field">
      <umkt-custom-input
        formControlName="nomeResponsavel"
        [placeholder]="'pages.partnerRegistration.inscription.step1.fields.nomeResponsavel.placeholder' | i18n"
        [floatingLabel]="true"
        [maxlength]="255"
        [showClearButton]="false"
      ></umkt-custom-input>
    </div>
    <div class="partner-inscription-field">
      <umkt-custom-input
        formControlName="email"
        type="email"
        [placeholder]="'pages.partnerRegistration.inscription.step1.fields.email.placeholder' | i18n"
        [floatingLabel]="true"
        [maxlength]="255"
        [showClearButton]="false"
      ></umkt-custom-input>
    </div>
  </div>
</form>
